import { Box, Flex } from "@chakra-ui/react"
import React from "react"
import bannerBG from "../assets/images/distributors.png"
import { breadCrumbFirstLevel, pageContentWidth } from "../common/commonConstants"
import { SubPage, SubPageContent } from "../components/SubPage"
import { RHeading3PT } from "../components/commons/RHeading3PT"
import { BreadCrumb } from "../components/commons/breadcrumb"
import { DistributorCard, type DistributersInterface } from "../components/commons/distributorCard"
import { StaticPageHeader } from "../components/commons/static-page-header"
import {
  AccuraLogoImg,
  DrillCutLogoImg,
  DrillFastLogoImg,
  Fyreguard,
  // GlobalLogo,
  SpecfastLogo,
  Youstalogo,
  powagroupLogoImg
} from "../components/images"

export const Distributors = (): JSX.Element => {
  const preferredPartners: DistributersInterface[] = [
    {
      title: "ACT",
      logo: powagroupLogoImg,
      logoW: "184px",
      logoH: "49px",
      website: "powagroup.com.au",
      email: "sales@powagroup.com.au",
      phone: "1300 303 366"
    },
    {
      title: "NSW",
      logo: DrillCutLogoImg,
      logoW: "186px",
      logoH: "36px",
      website: "drillcut.au",
      email: "sales@drillcut.com.au",
      phone: "(02) 9737 0099"
    },
    {
      title: "NSW",
      logo: powagroupLogoImg,
      logoW: "184px",
      logoH: "49px",
      website: "powagroup.com.au",
      email: "sales@powagroup.com.au",
      phone: "1300 303 366"
    },
    {
      title: "NT",
      logo: AccuraLogoImg,
      logoW: "159px",
      logoH: "47px",
      website: "acuragroup.com.au",
      email: "sales@acuragroup.com.au",
      phone: "1300 750 750"
    },
    {
      title: "QLD",
      logo: DrillFastLogoImg,
      logoW: "188px",
      logoH: "42px",
      website: "drillfast.com.au",
      email: "sales@drillfast.com.au",
      phone: "1300 923 414"
    },
    {
      title: "SA",
      logo: AccuraLogoImg,
      logoW: "159px",
      logoH: "47px",
      website: "acuragroup.com.au",
      email: "sales@acuragroup.com.au",
      phone: "1300 750 750"
    },
    {
      title: "TAS",
      logo: DrillCutLogoImg,
      logoW: "186px",
      logoH: "36px",
      website: "drillcut.au",
      email: "sales@drillcut.com.au",
      phone: "(03) 6272 1190"
    },
    {
      title: "VIC",
      logo: DrillCutLogoImg,
      logoW: "186px",
      logoH: "36px",
      website: "drillcut.au",
      email: "sales@drillcut.com.au",
      phone: "(03) 8301 9999"
    },
    {
      title: "WA",
      logo: AccuraLogoImg,
      logoW: "159px",
      logoH: "47px",
      website: "acuragroup.com.au",
      email: "sales@acuragroup.com.au",
      phone: "1300 750 750"
    }
  ]
  const otherDistributors: DistributersInterface[] = [
    {
      isOtherDistributor: true,
      title: "NSW",
      logo: Youstalogo,
      logoW: "173px",
      logoH: "38px",
      website: "yousta.com.au",
      email: "service@yousta.com.au",
      phone: "(02) 9792 3820"
    },
    {
      isOtherDistributor: true,
      title: "QLD",
      logo: Fyreguard,
      logoW: "174px",
      logoH: "42px",
      website: "fyreguard.com",
      phone: [
        {
          label: "Brisbane",
          value: "(07) 3865 4422"
        },
        {
          label: "Gold Coast",
          value: "(07) 5593 4955"
        }
      ]
    },
    {
      isOtherDistributor: true,
      title: "SPECFAST",
      logo: SpecfastLogo,
      logoW: "160px",
      logoH: "59px",
      website: "specfast.com.au",
      phone: [
        { label: "Cairns", value: "(07) 4031 6978" },
        { label: "Townsville", value: "(07) 4727 1111" },
        { label: "Dubbo", value: "(02) 6882 6011" },
        { label: "Auburn", value: "(02) 9750 9444" },
        { label: "Fyshwick", value: "(02) 6202 5800" },
        { label: "Lambton", value: "(02) 4952 4544" }
      ]
    }
  ]
  return (
    <SubPage>
      <StaticPageHeader title="Distributors" bg={bannerBG} imageOpacity={0.6} />
      <BreadCrumb options={{ ...breadCrumbFirstLevel, thirdLevel: { title: "Distributors" } }} />
      <SubPageContent innerBoxProps={{ w: ["100%", "100%", "100%", pageContentWidth, "70%", "70%"] }}>
        <Flex justify={"center"} mb={["24px", "24px", "23px"]}>
          <RHeading3PT text="Preferred Partners" />
        </Flex>
        <Flex justify={"center"} ml={["16px", "16px", "10px"]} pt={["2px", "2px", "0px"]}>
          <Box
            display="grid"
            gridTemplateColumns={["repeat(1, 1fr)", "repeat(3, 1fr)", "repeat(3, 1fr)", "repeat(3, 1fr)", "repeat(3, 1fr)"]}
            gap={"20px"}
            rowGap={["30px", "30px", "44px"]}
            justifyItems={"center"}
          >
            {preferredPartners.map((item, index) => (
              <Box key={item?.title} gridColumn={["initial", "initial", "initial", index === preferredPartners.length - 1 ? "span 4" : "initial"]}>
                <DistributorCard options={item} />
              </Box>
            ))}
          </Box>
        </Flex>
        <Flex mt={["34px", "34px", "50px"]} justify={"center"} mb="23px">
          <RHeading3PT text="Other Distributors" />
        </Flex>
        <Flex justify={"center"} ml={["16px", "16px", "34px"]} pt={["4px", "4px", "0px"]}>
          <Box
            display="grid"
            gridTemplateColumns={["repeat(1, 1fr)", "repeat(3, 1fr)", "repeat(3, 1fr)"]}
            gap={"20px"}
            rowGap={["30px", "30px", "44px"]}
            justifyItems={"center"}
          >
            {otherDistributors.map(item => (
              <React.Fragment key={item?.title}>
                <DistributorCard options={item} />
              </React.Fragment>
            ))}
          </Box>
        </Flex>
      </SubPageContent>
    </SubPage>
  )
}
